export const common = {
  'nav.overview': '사업개요',
  'nav.brand': '브랜드',
  'nav.environment': '입지환경',
  'nav.premium': '프리미엄',
  'nav.benefit': '베네핏 10',
  'nav.complex': '단지안내',
  'nav.unit': '세대안내',
  'nav.location': '오시는길',
  'nav.media': '홍보센터',
  'nav.customer': '관심고객등록',
  'nav.phone': '1668-1451',
  'footer.developer': '시행사',
  'footer.developer.name': '파주탄현민간임대 협동조합',
  'footer.developer.biz': '사업자등록번호',
  'footer.developer.biz.num': '828-87-03686',
  'footer.developer.address': '주소',
  'footer.developer.address.val': '경기도 파주시 탄현면 방촌로 688, 1층',
  'footer.agency': '광고대행',
  'footer.agency.name': '(주)리얼투데이',
  'footer.agency.ceo': '대표자명',
  'footer.agency.ceo.name': '김운철',
  'footer.agency.address': '주소',
  'footer.agency.address.val': '서울시 강남구 언주로 650, 9층(논현동 238-5)',
  'footer.agency.biz': '사업자번호',
  'footer.agency.biz.num': '214-88-75980',
  'footer.disclaimer1': '※ 본 홈페이지에 사용된 CG 및 이미지컷은 소비자의 이해를 돕기 위해 임의로 제작된 것입니다.',
  'footer.disclaimer2': '※ 본 홈페이지에 표시된 개발계획은 언론 및 지방자치단체 외 기타 기관에서 발표한 내용을 참조한 것으로, 국가기관, 지자체, 교육청 및 기타 관계기관의 상황에 따라 사업추진 중 일부변경 또는 지연 및 취소될 수 있으니 유의하시기 바랍니다.',
  'footer.site.address': '현장',
  'footer.site.address.val': '경기도 파주시 탄현면 축현리 562번지 일원',
  'footer.showroom.address': '홍보관',
  'footer.showroom.address.val': '경기도 파주시 다율동 1041-9',
  'popup.dontShow': '오늘 하루 보지않기',
  'popup.close': '팝업닫기',
};